/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Fix_DocsInputs */

const en_rd_fix_docs = /** @type {(inputs: Rd_Fix_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add docs/ or a PRD.md — the context an agent reads before it touches the code.`)
};

const id_rd_fix_docs = /** @type {(inputs: Rd_Fix_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan docs/ atau PRD.md — konteks yang dibaca agent sebelum menyentuh kode.`)
};

/**
* | output |
* | --- |
* | "Add docs/ or a PRD.md — the context an agent reads before it touches the code." |
*
* @param {Rd_Fix_DocsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_fix_docs = /** @type {((inputs?: Rd_Fix_DocsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Fix_DocsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_fix_docs(inputs)
	return en_rd_fix_docs(inputs)
});